import {
    HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = req.headers
            .append('Accept', 'application/json');
        if (req.url.startsWith('api')) {
            headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
        }

        return next.handle(req.clone({ headers }));
    }
}